// axios.js
import axios from "axios";
const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_DB_SERVER,
  withCredentials: true,
});

// Store refreshing promise to prevent race conditions
let isRefreshing = false;
let refreshSubscribers = [];

function onRefreshed(newToken) {
  refreshSubscribers.forEach((callback) => callback(newToken));
  refreshSubscribers = [];
}

function addRefreshSubscriber(callback) {
  refreshSubscribers.push(callback);
}

// Request Interceptor: attach access token
axiosInstance.interceptors.request.use(

  (config) => {
    const token = sessionStorage.getItem('accessToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
  
);


axiosInstance.interceptors.response.use(
  response => response, // Directly return successful responses.
  async error => {
    const originalRequest = error.config;
    // Status code 403: refsrehToken expired
    
    if (error.response.status === 403 && !originalRequest._retry) {
      originalRequest._retry = true; // Mark the request as retried to avoid infinite loops.

      if (isRefreshing) {
        
        return new Promise((resolve) => {
          addRefreshSubscriber((newToken) => {
            originalRequest.headers = {
              'Authorization': 'Bearer ' + newToken,
              "Content-Type": "application/json"
            }
            resolve(axiosInstance(originalRequest));
          });
        });
      }

      isRefreshing = true;
      const user = sessionStorage.getItem('user');

      try {
        
        const res = await axios.post(
          process.env.REACT_APP_DB_SERVER + '/refresh',
           ({ user }),
           { 
            headers: { 'Content-Type': 'application/json' },
            withCredentials: true }
        );
        
        const newToken = res.data.accessToken;
        sessionStorage.setItem("accessToken", newToken);

        onRefreshed(newToken);

        originalRequest.headers = {
              'Authorization': 'Bearer ' + newToken,
              "Content-Type": "application/json"
            }

        return axiosInstance(originalRequest);
      } catch (refreshError) {
        // If the refresh token is expired (after 30 days) - force login again
        if (refreshError.response?.status === 403) {
          console.error("Token refresh failed", refreshError);
          sessionStorage.removeItem("accessToken");
          window.location.href = "/login"; // force logout
          return Promise.reject(refreshError);
        }
      } finally {
        isRefreshing = false;
      }
        
    }

    return Promise.reject(error);
  }
);

export default axiosInstance